import type {
  TripPlanDto,
  TripPlanDetailDto,
  TripPlanCreateDto,
  TripPlanUpdateDto,
  PlanStageDto,
  PlanStageCreateDto,
  PlanStageUpdateDto,
  PlanConvertDto,
  PlanRouteDto,
} from '@camper-diary/shared';
import { api } from './client';

export type Plan = TripPlanDto;
export type PlanDetail = TripPlanDetailDto;
export type PlanStage = PlanStageDto;
export type PlanRoute = PlanRouteDto;

export function listPlans() {
  return api<Plan[]>('/plans');
}

export function getPlan(id: string) {
  return api<PlanDetail>(`/plans/${encodeURIComponent(id)}`);
}

export function createPlan(input: TripPlanCreateDto) {
  return api<Plan>('/plans', { method: 'POST', body: input });
}

export function updatePlan(id: string, input: TripPlanUpdateDto) {
  return api<Plan>(`/plans/${encodeURIComponent(id)}`, { method: 'PATCH', body: input });
}

export function deletePlan(id: string) {
  return api<null>(`/plans/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function createPlanStage(planId: string, input: PlanStageCreateDto) {
  return api<PlanStage>(`/plans/${encodeURIComponent(planId)}/stages`, {
    method: 'POST',
    body: input,
  });
}

export function updatePlanStage(planId: string, id: string, input: PlanStageUpdateDto) {
  return api<PlanStage>(
    `/plans/${encodeURIComponent(planId)}/stages/${encodeURIComponent(id)}`,
    { method: 'PATCH', body: input },
  );
}

export function deletePlanStage(planId: string, id: string) {
  return api<null>(
    `/plans/${encodeURIComponent(planId)}/stages/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
  );
}

export function reorderPlanStages(planId: string, ids: string[]) {
  return api<PlanStage[]>(`/plans/${encodeURIComponent(planId)}/stages/reorder`, {
    method: 'POST',
    body: { ids },
  });
}

export function getPlanRoute(planId: string) {
  return api<PlanRoute>(`/plans/${encodeURIComponent(planId)}/route`);
}

export function convertPlanToTrip(planId: string, input: PlanConvertDto) {
  return api<{ tripId: string; stagesCopied: number }>(
    `/plans/${encodeURIComponent(planId)}/convert-to-trip`,
    { method: 'POST', body: input },
  );
}
